const initialState = {
	isLoading: false,
	selected: false,
	currentlyViewedPage: false,
	pageViewsRegisteredIds: [], // The pages which have been seen by this user in this session.
	byId: {},
	postsById: {},
	loadingById: {},
	appendedById: {}
}

export default function pageReducer( state = initialState, action ) {
	const { type, payload } = action
	let newLoadingById

	switch ( type ) {
		case 'REQUEST_PAGE_DATA':
			let isLoading = payload.requestOnly ? state.isLoading : true
			newLoadingById = {
				...state.loadingById
			}

			if ( 'more-posts' == payload.type ) {
				newLoadingById = {
					...state.loadingById,
					morePosts: true
				}
			} else {
				newLoadingById = {
					...state.loadingById,
					[ payload.slug ]: true
				}
			}

			return {
				...state,
				isLoading: isLoading,
				error: false,
				loadingById: newLoadingById
			}

		case 'RECEIVE_PAGE_DATA':
			let newById = {
				...state.byId
			}
			let newPostsById = {
				...state.postsById
			}
			newLoadingById = {
				...state.loadingById
			}

			if ( 'posts' == payload.type ) {
				newLoadingById = {
					...state.loadingById,
					[ 'id_' + payload.categorySlug ]: false
				}

				if ( newPostsById[ 'id_' + payload.categorySlug ] ) {
					newPostsById[ 'id_' + payload.categorySlug ] = payload.data
				} else {
					newPostsById = {
						[ 'id_' + payload.categorySlug ]: payload.data,
						...state.postsById
					}
				}
			} else if ( 'more-posts' == payload.type ) {
				newLoadingById = {
					...state.loadingById,
					morePosts: false
				}

				newPostsById[ 'id_' + payload.categorySlug ].items = {
					...newPostsById[ 'id_' + payload.categorySlug ].items,
					...payload.data.items
				}
			} else {
				newLoadingById = {
					...state.loadingById,
					[ 'id_' + payload.slug ]: false
				}

				if ( newById[ 'id_' + payload.slug ] ) {
					newById[ 'id_' + payload.slug ] = payload.data
				} else {
					newById = {
						[ 'id_' + payload.slug ]: payload.data,
						...state.byId
					}
				}
			}

			return {
				...state,
				isLoading: false,
				error: false,
				byId: newById,
				postsById: newPostsById,
				loadingById: newLoadingById
			}

		case 'RECEIVE_PAGE_ERROR':
			return {
				...state,
				isLoading: false,
				error: true
			}

		case 'SET_CURRENT_PAGE':
			let selected = state.selected

			if ( state.byId[ 'id_' + payload ] ) {
				selected = state.byId[ 'id_' + payload ]
			}

			return {
				...state,
				selected: selected,
				currentlyViewedPage: selected,
				appendedById: {}
			}

		case 'SET_CURRENTLY_VIEWED_PAGE':
			let currentlyViewedPage = state.currentlyViewedPage

			if ( state.byId[ 'id_' + payload ] ) {
				currentlyViewedPage = state.byId[ 'id_' + payload ]
			}

			return {
				...state,
				currentlyViewedPage: currentlyViewedPage
			}

		case 'UPDATE_PAGE_VIEWS_REGISTERED':
			return {
				...state,
				pageViewsRegisteredIds: state.pageViewsRegisteredIds.concat( payload )
			}

		case 'APPEND_PAGE':
			let newAppendedById = {
				...state.appendedById
			}

			if ( state.byId[ 'id_' + payload ] ) {
				newAppendedById = {
					...state.appendedById,
					[ 'id_' + payload ]: state.byId[ 'id_' + payload ]
				}
			}

			return {
				...state,
				appendedById: newAppendedById
			}
	}

	return state
}
